export const GET_COMMON_IMAGES= 'GET_COMMON_IMAGES'
export const GET_COMMON_IMAGES_SUCCESS= 'GET_COMMON_IMAGES_SUCCESS'
export const GET_COMMON_IMAGES_ERROR='GET_COMMON_IMAGES_ERROR'

export const GetCommonImages= (data) => ({
    type: GET_COMMON_IMAGES,
    payload: data
});
